<template>
  <v-app id="login">
    <v-main class="background-home">
      <v-container fluid fill-height class="d-flex flex-column align-center justify-center">
        <v-img :src="logo" max-height="90" contain />
        <div style="height: 100px; width: 100%"></div>
        <v-btn large color="primary" :loading="loading" @click="login" style="width: 300px"> Iniciar sesión </v-btn>
        <div style="height: 100px; width: 100%"></div>
        <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
          {{ msgError }}
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { loginMsal, initMsal } from '@utils/authService'

export default {
  name: 'login',
  data: () => ({
    host: process.env.VUE_APP_API_SERVER,
    name: process.env.VUE_APP_NAME,
    path: '/pub/login',
    loading: false,
    error: false,
    msgError: '',
    logo: require('@/assets/logo.png'),
    form: {
      email: '',
      password: ''
    },
    rules: {
      email: [(v) => !!v || '', (v) => (v && v.length <= 255) || ''],
      password: [(v) => !!v || '', (v) => (v && v.length <= 255) || '']
    }
  }),
  methods: {
    async login() {
      try {
        await initMsal()
        const { accessToken, account } = await loginMsal()
        this.loading = true
        const data = {
          access_token: accessToken,
          dispositivo: {
            idunico: '',
            modelo: '',
            sistema_operativo: ''
          },
          token: ''
        }
        this.axios
          .post(this.host + this.path, { data })
          .then((response) => {
            let res = response.data
            this.$session.start()
            this.$session.set('jwt', res.token)
            this.$router.push('/client/Search')
          })
          .catch((error) => {
            this.error = true
            if (error.response) {
              this.msgError = error.response.data.message
            } else {
              this.msgError = 'Servicio no disponible. Intente más tarde'
            }
          })
          .finally(() => {
            this.loading = false
          })
      } catch (e) {}
    }
  }
}
</script>

<style scoped></style>
